module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAWCAYAAADq8U2pAAAAFUlEQVQYV2N89+7dfwYGBgbGocwAAOP4U12+5HXiAAAAAElFTkSuQmCC"